// LiveOrdersContext.tsx
import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { socket } from "../socket";
import Order from "../models/Order";

// --- Types ---
// export interface Order {
//   id: string;
//   customerName: string;
//   amount: number;
//   status: string;
//   [key: string]: any; // for other dynamic fields
// }

interface LiveOrdersContextType {
  orders: Order;
  setOrders: React.Dispatch<React.SetStateAction<Order>>;
}

interface LiveOrdersProviderProps {
  children: ReactNode;
}

// --- Context ---
const LiveOrdersContext = createContext<LiveOrdersContextType | null>(null);

// --- Provider ---
export const LiveOrdersProvider: React.FC<LiveOrdersProviderProps> = ({ children }) => {
  const [orders, setOrders] = useState<Order>({} as Order);

  useEffect(() => {
    // Listen for new orders from backend
    const handleNewOrder = (data: Order) => {
    //   console.log("New order received:", data.order);
      setOrders(data);
    // console.log(data);
    };

    socket.on("order_created", handleNewOrder);

    // Cleanup on unmount
    return () => {
      socket.off("order_created", handleNewOrder);
    };
  }, []);

  return (
    <LiveOrdersContext.Provider value={{ orders, setOrders }}>
      {children}
    </LiveOrdersContext.Provider>
  );
};

// --- Hook for easier consumption ---
export const useLiveOrders = (): LiveOrdersContextType => {
  const context = useContext(LiveOrdersContext);
  if (!context) {
    throw new Error("useLiveOrders must be used within a LiveOrdersProvider");
  }
  return context;
};